import { Timeline } from "@mui/lab";
import StatusHistoryTimelineItem from "./StatusHistoryTimelineItem";
import { receiveStatus } from "../../util/receiveStatus";
import { isBefore, isAfter, parseJSON } from "date-fns";
import { useStyles } from "./History.styles";
import { StatusHistoryListProps } from "./types";

const usePreparedStatusHistory = (statusHistoryList, arrivals) => {
	if (!arrivals || arrivals?.length === 0) return statusHistoryList;

	// Filter out arrived entries (will add them through arrivals list)
	const filteredHistory = statusHistoryList.filter((i) => i.status !== receiveStatus.arrived);
	// Create arrival history entries
	const arrivalHistoryEntries = arrivals.map((a) => {
		return {
			...a,
			status: receiveStatus.arrived,
			userName: a.createdByUserName,
		};
	});
	// Adds arrival entries to history list
	filteredHistory.unshift(...arrivalHistoryEntries);

	// Sort by timestamp descending (most recent date at the top)
	const statusHistorySorted = filteredHistory.sort((a, b) => {
		const timestampA = parseJSON(a.timestamp);
		const timestampB = parseJSON(b.timestamp);
		if (isBefore(timestampA, timestampB)) return 1;
		if (isAfter(timestampA, timestampB)) return -1;
		return 0; // propably equal
	});
	return statusHistorySorted;
};

function StatusHistoryList(props: StatusHistoryListProps) {
	const { statusHistoryList, arrivals } = props;
	const classes = useStyles();
	const filteredHistory = usePreparedStatusHistory(statusHistoryList, arrivals);

	return (
		<Timeline className={classes.timeline}>
			{filteredHistory.map((row, index) => (
				<StatusHistoryTimelineItem
					key={index}
					status={row.status}
					timestamp={row.timestamp}
					userName={row.userName}
					consignmentNumber={row.consignmentNumber}
					carrier={row.carrier}
					numberReceived={row.numberReceived}
					inFull={row.inFull}
				/>
			))}
		</Timeline>
	);
}

export default StatusHistoryList;
